import axios from '../axios';
// eslint-disable-next-line import/order
import useAxios, { configure } from 'axios-hooks';

configure({ axios });

export default function useGetKeywordsUsedByContributor(contributorId, limit) {
  const searchQueryId = window.Livewire?.request?.searchQuery?.id;
  return useAxios({
    cache: { ignoreCache: true },
    url: `/api/v1/keywords/contributor/${contributorId}`,
    method: 'GET',
    params: { search_query_id: searchQueryId, top: limit },
  }, { manual: true });
}
